export default {
      id: "button_edit-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "img/icons.svg#button_edit",
      toString: function () {
        return this.url;
      }
    }